<template>
  <div class="iotcharging-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('sm2')" inline>
        <el-form-item :label="$t('finance.name1')" prop="searchTime">
          <el-select v-model="queryInfo.tenantId" :placeholder="$t('public.name1')" clearable>
            <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('bike.name34')" prop="cycleId">
          <el-input class="input-layout" v-model="queryInfo.cycleId" :placeholder="$t('public.name5')" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('bike.name184')" prop="cycleName">
          <el-input class="input-layout" v-model="queryInfo.cycleName" :placeholder="$t('public.name5')" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('finance.name44')" prop="status">
          <el-select v-model="queryInfo.status"  :placeholder="$t('public.name1')" clearable>
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('operate.name86')" prop="orderNo">
          <el-input class="input-layout" v-model="queryInfo.orderNo" :placeholder="$t('public.name5')" clearable> </el-input>
        </el-form-item>
        <el-form-item :label="$t('finance.name45')" prop="searchTime">
          <el-date-picker
            v-model="queryInfo.searchTime"
            type="datetimerange"
           value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
            align="left"
            @change="searchTimeclear"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
          <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="add-user">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="addOrder(null)">{{ $t('operate.name11') }}</el-button>
    </div>
    <el-table :data="orderList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('operate.name91')" prop="orderNo" sortable></el-table-column>
      <el-table-column :label="$t('finance.name49')" prop="tenantName" sortable></el-table-column>
      <el-table-column :label="$t('finance.name50')" prop="cycleId" sortable></el-table-column>
      <el-table-column :label="$t('bike.name52')" prop="cycleName" sortable></el-table-column>
      <el-table-column :label="$t('finance.name48')" prop="num" sortable></el-table-column>
      <!-- <el-table-column label="单价" prop="price" sortable></el-table-column> -->
      <!-- <el-table-column label="其他费用" prop="other" sortable></el-table-column> -->
      <!-- <el-table-column label="总价" prop="totle" sortable></el-table-column> -->
      <el-table-column :label="$t('finance.name46')" prop="startTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.startTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('finance.name47')" prop="endTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.endTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('finance.name11')" prop="note" sortable></el-table-column>
      <el-table-column :label="$t('operate.name23')" prop="orderState" sortable></el-table-column>
      <el-table-column :label="$t('finance.name15')" width="188px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="addOrder(scope.row)">编辑</el-button>
          <el-button type="text" @click="showStatusDialog(scope.row)">状态</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <AppDialog width="440px" :title="$t('tabmenu.name43')" v-if="orderDialog" :visible.sync="orderDialog" :before-close="close">
      <el-form ref="orderFormRef" :model="orderInfo" :rules="orderInfoRules" :label-width="formLabelWidth('md3')">
        <el-form-item prop="tenantId" :label="$t('finance.name1')">
          <el-select v-model="orderInfo.tenantId" :placeholder="$t('public.name1')" style="width:100%;">
            <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="orderNo" :label="$t('operate.name86')">
          <el-input v-model="orderInfo.orderNo" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="cycleId" :label="$t('bike.name184')">
          <el-select v-model="orderInfo.cycleId" :placeholder="$t('public.name1')" style="width:100%;">
            <el-option v-for="item in modelOptions" :key="item.ebikeModelId" :label="item.ebikeModelName" :value="item.ebikeModelId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="num" :label="$t('finance.name48') + '：'">
          <el-input v-model="orderInfo.num" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="other" label="单价：">
          <el-input v-model="orderInfo.other" :placeholder="$t('public.name5')"></el-input>
        </el-form-item> -->
        <!-- <el-form-item prop="price" label="其他费用：">
          <el-input v-model="orderInfo.price" :placeholder="$t('public.name5')"></el-input>
        </el-form-item> -->
        <el-form-item prop="startTime" :label="$t('finance.name46') + '：'">
          <el-date-picker style="width:100%;" v-model="orderInfo.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('public.name6')"></el-date-picker>
        </el-form-item>
        <el-form-item prop="endTime" :label="$t('finance.name47') + '：'">
          <el-date-picker  style="width:100%;"  v-model="orderInfo.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('public.name6')"></el-date-picker>
        </el-form-item>
        <el-form-item prop="note" :label="$t('finance.name11') + '：'">
          <el-input v-model="orderInfo.note" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="file" :label="$t('finance.name51')">
          <input v-model="orderInfo.file" style="display: none"   />
          <el-upload
            class="upload-demo"
            action=""
            :limit="1"
            :file-list="fileList"
            :on-remove="handleRemove"
            :http-request="
                (e) => {
                  handleUpLoadFile(e)
                }
              "
          >
            <el-button size="small" type="primary">{{ $t('operate.name34') }}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>

    <AppDialog width="388px" :title="$t('finance.name52')" v-if="orderStatusDialog" :visible.sync="orderStatusDialog" :before-close="close">
      <el-form ref="orderStatusFormRef" :model="orderStatusInfo" :rules="orderStatusRules" :label-width="formLabelWidth('md')">
        <el-form-item prop="status" :label="$t('finance.name44')">
          <el-select v-model="orderStatusInfo.status" :placeholder="$t('public.name1')">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitStatusForm" :loading="loading">{{$t('public.name13')}}</el-button>
        <el-button @click="close">{{$t('public.name14')}}</el-button>
      </span>
    </AppDialog>
  </div>
</template>
<script>
import { orderList, orderAdd, orderEdit, orderStatus } from '@/api/finance.js'
import { tenantList, uploadFile } from '@/api/manage.js'
import { findEbikeModelPage } from '@/api/bike.js'
import { mapGetters } from 'vuex'
import AppDialog from '@/components/AppDialog/index.vue'
export default {
  components: { AppDialog },
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      queryInfo: {
        cycleId: '',
        cycleName: '',
        limit: 10,
        orderNo: '',
        page: 1,
        status: '',
        tenantId: '',
        searchTime: null
      },
      loading: false,
      fileList: [],
      statusOptions: [
        { value: 1, label: '进行中' }
      ],
      orderStatusInfo: {
        orderId: '',
        status: 0
      },
      orderStatusRules: {
        status: [
          {
            required: true,
            message: this.$t('finance.name41'),
            trigger: 'blur'
          }
        ]
      },
      orderStatusDialog: false,
      modelOptions: [],
      tableLoading: false,
      orderDialog: false,
      orderList: [],
      total: 0,
      orderInfo: {
        cycleId: '',
        cycleName: '',
        endTime: '',
        file: '',
        note: '',
        num: '',
        orderNo: '',
        orderId: '',
        orderState: 0,
        other: '',
        price: '',
        startTime: '',
        tenantId: '',
        tenantName: '',
        totle: ''
      },
      tenantOptions: [],
      type: 1,
      orderInfoRules: {
        tenantId: [
          {
            required: true,
            message: this.$t('bike.name481'),
            trigger: 'blur'
          }
        ],
        orderNo: [
          {
            required: true,
            message: this.$t('finance.name42'),
            trigger: 'blur'
          }
        ],
        cycleId: [
          {
            required: true,
            message: this.$t('finance.name43'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    this.getTenantList()
    this.getEbikeModelList()
    this.queryList()
  },
  mounted() {},
  methods: {
    resetQuery() {
      this.queryInfo = {
        cycleId: '',
        cycleName: '',
        limit: 10,
        orderNo: '',
        page: 1,
        status: '',
        searchTime: null,
        tenantId: ''
      }
      this.queryList()
    },
    getPageList() {
      this.queryInfo.page = 1
      this.queryInfo.limit = 10
      this.queryList()
    },
    queryList() {
      this.tableLoading = true
      const data = {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit
      }
      if (this.queryInfo.tenantId) {
        data.tenantId = this.queryInfo.tenantId
      }
      if (this.queryInfo.cycleId) {
        data.cycleId = this.queryInfo.cycleId
      }
      if (this.queryInfo.cycleName) {
        data.cycleName = this.queryInfo.cycleName
      }
      if (this.queryInfo.orderNo) {
        data.orderNo = this.queryInfo.orderNo
      }
      if (this.queryInfo.status) {
        data.status = this.queryInfo.status
      }
      if (this.queryInfo.searchTime) {
        const { startTime, endTime } = this.$tz.rangeToAccountQuery(this.queryInfo.searchTime)
        data.startTime = startTime
        data.endTime = endTime
      }
      orderList(data).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.orderList = res.data.list
          this.total = res.data.total
        }
      }).catch(() => {
        this.tableLoading = false
      })
    },
    getEbikeModelList() {
      const data = {
        pageNumber: 1,
        pageSize: 10,
        tenantId: this.userinfo.tenantId
      }
      findEbikeModelPage(data).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.modelOptions = res.data.ebikeModelPage.records
        }
      })
    },
    addOrder(row) {
      if (row == null) {
        this.type = 1
      } else {
        this.type = 2
        this.fileList = [{ name: row.sysFile?.fileName, url: row.sysFile?.fileUrl }]
        this.orderInfo = {
          cycleId: row.cycleId,
          cycleName: row.cycleName,
          endTime: row.endTime,
          file: row.sysFile?.fileUrl || '',
          note: row.note,
          num: row.num,
          orderNo: row.orderNo,
          orderId: row.orderId,
          orderState: row.orderState,
          other: row.other,
          price: row.price,
          startTime: row.startTime,
          tenantId: row.tenantId,
          tenantName: row.tenantName,
          totle: row.totle
        }
      }
      this.orderDialog = true
    },
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2
      }

      tenantList(data)
        .then(res => {
          this.tenantOptions = res.data.list
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    handleRemove(file, fileList) {
      this.orderInfo.file = ''
      this.fileList = []
    },
    handleUpLoadFile(param) {
      this.fileList = []
      const formData = new FormData()
      formData.append('multipart', param.file)
      const loading = this.$loading({
        lock: true,
        text: this.$t('public.name35'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      uploadFile(formData)
        .then(res => {
          loading.close()
          if (res.code === 200) {
            this.orderInfo.file = res.data.fileId
            this.fileList = [{ name: res.data.fileName, url: res.data.fileUrl }]
            this.$message.success(this.$t('public.name42'))
          }
        })
        .catch(res => {
          this.fileList = []
          loading.close()
        })
    },
    submitForm() {
      this.$refs.orderFormRef.validate(valid => {
        if (valid) {
          this.loading = true
          if (this.type === 1) {
            orderAdd(this.orderInfo).then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.queryList()
              }
            }).catch(() => {
              this.loading = false
            })
          } else {
            orderEdit(this.orderInfo).then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.queryList()
              }
            }).catch(() => {
              this.loading = false
            })
          }
        } else {
          return false
        }
      })
    },
    showStatusDialog(row) {
      this.orderStatusInfo.orderId = row.orderId
      this.orderStatusDialog = true
    },
    submitStatusForm() {
      this.$refs.orderStatusFormRef.validate((valid) => {
        if (valid) {
          this.loading = true
          orderStatus(this.orderStatusInfo)
            .then((res) => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.queryList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    close() {
      this.orderDialog = false
      this.orderInfo = {
        cycleId: '',
        cycleName: '',
        endTime: '',
        file: '',
        note: '',
        num: '',
        orderNo: '',
        orderId: '',
        orderState: 0,
        other: '',
        price: '',
        startTime: '',
        tenantId: '',
        tenantName: '',
        totle: ''
      }
      this.fileList = []
      this.orderStatusInfo = {
        orderId: '',
        status: 0
      }
      this.orderStatusDialog = false
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.queryList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.queryList()
    }
  }
}
</script>
<style lang="scss">
.el-dialog__body {
  display: flex;
  justify-content: center;
}
</style>
<style lang="scss" scoped>
.iotcharging-container {
  display: flex;
  flex-direction: column;
  .search-layout {
    display: flex;
    justify-content: space-between;
    .bt-layout {
      display: flex;
      flex-direction: row;
      height: 36px;
    }
  }
}
</style>
